module.exports = __webpack_public_path__ + "img/02-promotion-img-coupon-tablet@3x.2981cf31.png";